var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaintenance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#963E97"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8L19.1474 12.5572L24.5 14.1117L21.0927 18.4824L21.2528 24L16 22.1441L10.7472 24L10.9073 18.4824L7.5 14.1117L12.8526 12.5572L16 8ZM14.5105 16.4761H13.0209C13.0209 17.2453 13.3246 17.984 13.8673 18.5346C14.4099 19.0853 15.1485 19.4042 15.9255 19.4235C16.7025 19.4427 17.4563 19.1607 18.026 18.6376C18.5958 18.1145 18.9365 17.3917 18.9753 16.6235L18.9791 16.4761H17.4895C17.4913 16.8587 17.3427 17.2269 17.0752 17.503C16.8076 17.7791 16.4422 17.9415 16.0559 17.9558C15.6697 17.9702 15.2929 17.8354 15.0052 17.5799C14.7175 17.3244 14.5415 16.9683 14.5142 16.5867L14.5105 16.4761Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.13c587e8f9ef58814f579af5ea635ea3.svg";
export { ForwardRef as ReactComponent };